import { ProjectSize } from '@/types/api'

/**
 * Canonical project-size options shared across lead/project forms and the
 * Won transition dialog. Keep this as the single source of truth.
 */
export const projectSizeOptions = [
  { value: ProjectSize.TINY, label: 'Tiny (<$1k)' },
  { value: ProjectSize.SMALL, label: 'Small ($1k-$4k)' },
  { value: ProjectSize.MEDIUM, label: 'Medium ($5k-$10k)' },
  { value: ProjectSize.BIG, label: 'Big (+$10k-$20k)' },
  { value: ProjectSize.HUGE, label: 'Huge (+$20k)' },
]
